import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import DesktopDevPageSideVideoSideGak from './gak/DesktopDevPageSideVideoSide';
import DesktopDevPageSideVideoSideNitro from './nitro/DesktopDevPageSideVideoSide';
const DesktopDevPageSideVideoSide = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageSideVideoSideGak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageSideVideoSideNitro, {
        safety: safety
    });
};
DesktopDevPageSideVideoSide.displayName = 'DesktopDevPageSideVideoSide';
export default DesktopDevPageSideVideoSide;
